// angular
import { AfterViewInit, Component, HostListener, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CoreService } from '../../core/core.service';
import { AppService } from '../../app.service';
import { KlenicoMeService } from '../me.service';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { MeQuickTestService } from './quick-test.service';

@Component({
    selector: 'me-quick-test',
    templateUrl: './quick-test.component.html',
    styleUrls: ['./quick-test.component.scss'],
    providers: [MeQuickTestService],
    encapsulation: ViewEncapsulation.None,

})

export class MeQuickTestComponent implements OnInit, AfterViewInit {
    data: any;
    description: any;
    url = 'lp/quick-test';
    urlQuestion = 'lp/quick-test/questions/';
    currentQuestion = 12;
    isLandingPage = true;
    question: any;
    rating = 0;
    ratings = [];

    @ViewChild('modal',  {static: false}) modal: ModalDirective;

    constructor(
        public appService: AppService,
        public meService: KlenicoMeService,
        public translate: TranslateService,
        public route: ActivatedRoute,
        public coreService: CoreService,
        public meQuickTestService : MeQuickTestService,
        public router: Router
    ) {
       
    }

    ngAfterViewInit() {
        this.meService.isLandingPage = true;
        this.route.queryParams.subscribe(params => {
            if (params['open']) {
                this.getStepContent();
                this.modal.show();
            }
        });
    }

    ngOnInit() {
        this.getContent();
        this.translate.onLangChange.subscribe(value => {
            this.getContent();
        });
    }

    getContent() {
        this.appService.getStoryBlokDataForClinic(this.url).subscribe(res => {
            this.data = res['story']['content']['content'][0] ?? [];
            this.description = res['story']['content']['description'];
            this.appService.isLoading = false;
        });
    }

    getStepContent() {
        this.appService.getStoryBlokDataForClinic(this.urlQuestion + this.currentQuestion).subscribe(res => {
            this.question = res['story']['content'] ?? [];
            this.appService.isLoading = false;
        });
    }

    back() {
        history.back();
    }

    next() {
        this.ratings.push({
            'id' : this.currentQuestion,
            'answer' : this.rating,
            'category' : this.question.category
        });

        this.currentQuestion--;
        this.rating = 0;
        this.getStepContent();

        if (this.currentQuestion == 0) {
            this.appService.isLoading = true;
            let body = {
                'answers' : JSON.stringify(this.ratings)
            }
            
            this.meQuickTestService.createQuickTest(body).subscribe(res => {
                let data = res['data'];
                let categories = JSON.parse(data['categories']);
                let isHarm = data.self_harm;
                let size = categories.length;


                let slug = 'apparent-signs';
                if (categories.length === 0) {
                    slug = 'no-signs';
                }
                if (isHarm) {
                    slug = 'severe-signs';
                }

                let url = '/me/quick-test/result/' + slug + '/' + size + '/' +isHarm;
                this.appService.isLoading = false;
                this.router.navigate([url]);
            });
        }
    }
}
